import { render, staticRenderFns } from "./CodigoLoader.vue?vue&type=template&id=b4b04b02&scoped=true&"
import script from "./CodigoLoader.vue?vue&type=script&lang=ts&"
export * from "./CodigoLoader.vue?vue&type=script&lang=ts&"
import style0 from "./CodigoLoader.vue?vue&type=style&index=0&id=b4b04b02&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b4b04b02",
  null
  
)

export default component.exports